const FAMILIES_PREFIX = '/families';

export const FamiliesApi = {
  myFamily: () => `${FAMILIES_PREFIX}/me`,
  memberBalance: (familyId: string, memberId: string) => `${FAMILIES_PREFIX}/${familyId}/members/${memberId}/balance`,
  addFamilyMember: (familyId: string) => `${FAMILIES_PREFIX}/${familyId}/members`,
  removeFamilyMember: (familyId: string, memberUserId: string) =>
    `${FAMILIES_PREFIX}/${familyId}/members/${memberUserId}`,
  resendMemberActivation: (familyId: string, memberUserId: string) =>
    `${FAMILIES_PREFIX}/${familyId}/members/${memberUserId}/resend-activation`,
  registerFamily: () => `${FAMILIES_PREFIX}/register`,
};
